import Cookies from 'js-cookie';

const getCookieDomain = () => {
  const host = window.location.host.substring(
    window.location.host.indexOf('.'),
  );
  const isLocalhost = host.includes('localhost');

  return {
    domain: isLocalhost ? 'localhost' : host,
  };
};

export const setAuthCookie = (token) => {
  Cookies.set('exprowhite_trading', token, getCookieDomain());
};

export const removeAuthCookie = () => {
  Cookies.remove('exprowhite_trading', getCookieDomain());
};

export const getAllCookies = () => Cookies.get();
